import { render } from "./ProjectSummaryCompletedStats.vue?vue&type=template&id=e76cb0aa"
import script from "./ProjectSummaryCompletedStats.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCompletedStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__